import { Location } from "@/models/jobs/Location";

export class LocationInfo {
  public latLong: Location = new Location();
  public radius?: number;
  public locationType: string = '';
  public location: string = '';
  public locShortName: string= '';
  public facilityId?: number;

}
